import { render, staticRenderFns } from "./SaveLayout.vue?vue&type=template&id=231cfd54&scoped=true"
import script from "./SaveLayout.vue?vue&type=script&lang=js"
export * from "./SaveLayout.vue?vue&type=script&lang=js"
import style0 from "./SaveLayout.vue?vue&type=style&index=0&id=231cfd54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231cfd54",
  null
  
)

export default component.exports